"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rangeValidator_1 = require("../Validators/rangeValidator");
// @ts-expect-error This nodule does not have TS type definitions and we are OK with that.
const property_filter_parser_1 = __importDefault(require("@swegon/property-filter-parser"));
const result_1 = __importDefault(require("../Utility/result"));
const statusType_1 = require("../Utility/statusType");
class UnitConverter {
    constructor(measurementUnitsDto) {
        this.setMeasurementUnitsDto = (measurementUnitsDto) => {
            this.measurementUnitsDto = measurementUnitsDto;
        };
        this.getPropertyValues = (properties, name, propertyValueSet = null) => {
            var _a;
            const property = (_a = properties === null || properties === void 0 ? void 0 : properties.find((p) => p.name === name)) !== null && _a !== void 0 ? _a : undefined;
            if (!property) {
                return [];
            }
            const filteredProperties = property.value
                .filter((v) => property_filter_parser_1.default.isValid(v.property_filter, propertyValueSet))
                .map((v) => v.value.replace(/^"|"$/g, ""));
            return filteredProperties;
        };
        this.getAllDefaultProperties = (properties, propertyValueSet = null) => {
            const result = {};
            properties.forEach((p) => {
                const found = p.def_value.find((v) => property_filter_parser_1.default.isValid(v.property_filter, propertyValueSet || {}));
                if (found) {
                    result[p.name] = found.value.replace(/^"|"$/g, "");
                }
            });
            return result;
        };
        this.isString = (value) => {
            return typeof value === "string" || value instanceof String;
        };
        this.untrimProperties = (obj = null) => {
            if (!obj)
                return {};
            const untrimmed = {};
            Object.keys(obj).forEach((key) => {
                const value = obj[key];
                if (value && this.isString(value)) {
                    const trimmed = value.replace(/^"|"$/g, "");
                    untrimmed[key] = `"${trimmed}"`;
                }
            });
            return untrimmed;
        };
        this.trimProperties = (obj) => {
            if (!obj) {
                return null;
            }
            const trimmed = {};
            Object.keys(obj).forEach((key) => {
                const value = obj[key];
                if (value && this.isString(value)) {
                    trimmed[key] = value.replace(/^"|"$/g, "");
                }
            });
            return trimmed;
        };
        this.getGuiUnit = (guiUnitType, unit) => {
            if (unit === "SI") {
                const siUnits = this.getSIDefaults();
                return siUnits[guiUnitType];
            }
            if (unit === "IP") {
                const ipUnits = this.getIPDefaults();
                return ipUnits[guiUnitType];
            }
            return undefined;
        };
        this.getDefaultSettings = (data, filterUnit) => {
            const measurementProperties = data.property;
            const pvsForPropertySelection = this.untrimProperties(filterUnit);
            const pvs = Object.assign(Object.assign({}, this.getAllDefaultProperties(measurementProperties, pvsForPropertySelection)), this.trimProperties(filterUnit));
            const measurementUnits = this.getAllDefaultProperties(measurementProperties, this.untrimProperties(pvs));
            return Object.assign(Object.assign({}, measurementUnits), this.trimProperties(filterUnit));
        };
        this.getSettings = () => {
            var _a, _b;
            const measurementProperties = (_b = (_a = this.measurementUnitsDto) === null || _a === void 0 ? void 0 : _a.property) !== null && _b !== void 0 ? _b : [];
            const unitSettings = {};
            measurementProperties.forEach((p) => {
                // Use visibility_filter to allow different applications (AHU, ICD) to use same settings and data but show different options
                // Empty property value set since AHU does not have any application specific settings
                if (property_filter_parser_1.default.isValid(p.visibility_filter, {})) {
                    unitSettings[p.name] = this.getPropertyValues(measurementProperties, p.name, this.untrimProperties());
                }
            });
            return unitSettings;
        };
        this.convertOldSettings = (oldSettings) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const unitsToConvert = {
                temperature: [{ Celsius: "SI" }, { Fahrenheit: "IP" }],
                airFlow: [
                    { CubicMeterPerSecond: "m3_s" },
                    { CubicMeterPerHour: "m3_h" },
                    { CubicFeetPerMinute: "feet3_min" },
                    { LiterPerSecond: "l_s" },
                ],
                waterFlow: [
                    { LiterPerSecond: "l_s" },
                    { LiterPerHour: "l_h" },
                    { GallonsPerMinute: "gpm" },
                ],
                capacityCoil: [
                    { Watt: "W" },
                    { KiloWatt: "kW" },
                    { BtuPerHour: "btu_h" },
                    { HorsePower: "btu_h" },
                ],
                capacityFan: [
                    { Watt: "W" },
                    { KiloWatt: "kW" },
                    { BtuPerHour: "hp" },
                    { HorsePower: "hp" },
                    { BrakeHorsePower: "hp" },
                ],
                capacityCoilEl: [
                    { Watt: "W" },
                    { KiloWatt: "kW" },
                    { BtuPerHour: "btu_h" },
                    { HorsePower: "btu_h" },
                ],
                pressureWater: [
                    { Pascal: "Pa" },
                    { KiloPascal: "kPa" },
                    { FootOfWaterColumn: "ftwc" },
                ],
                soundLevel: [{ LPA: "LPA" }, { NC: "NC" }, { NR: "NR" }],
            };
            const newSettings = {
                unit: Object.values((_a = unitsToConvert.temperature.find((t) => t[oldSettings["temperature"]])) !== null && _a !== void 0 ? _a : {})[0],
                airFlow: Object.values((_b = unitsToConvert.airFlow.find((t) => t[oldSettings["airFlow"]])) !== null && _b !== void 0 ? _b : {})[0],
                waterFlow: Object.values((_c = unitsToConvert.waterFlow.find((t) => t[oldSettings["waterFlow"]])) !== null && _c !== void 0 ? _c : {})[0],
                capacityCoil: Object.values((_d = unitsToConvert.capacityCoil.find((t) => t[oldSettings["capacity"]])) !== null && _d !== void 0 ? _d : {})[0],
                capacityFan: Object.values((_e = unitsToConvert.capacityFan.find((t) => t[oldSettings["capacityFanBhp"] || oldSettings["capacity"]])) !== null && _e !== void 0 ? _e : {})[0],
                capacityCoilEl: Object.values((_f = unitsToConvert.capacityCoilEl.find((t) => t[oldSettings["capacityElHeat"] || oldSettings["capacity"]])) !== null && _f !== void 0 ? _f : {})[0],
                waterPressure: Object.values((_g = unitsToConvert.pressureWater.find((t) => t[oldSettings["pressureWater"]])) !== null && _g !== void 0 ? _g : {})[0],
                soundLevel: Object.values((_h = unitsToConvert.soundLevel.find((t) => t[oldSettings["soundLevel"] || "LPA"])) !== null && _h !== void 0 ? _h : {})[0],
            };
            return newSettings;
        };
        // patch will make sure that userSettings include any new unit types that are added to SI or IP defaults
        this.patchUserUnitSettings = (measurementUnitData, measurementUnits) => {
            const allSettings = this.getDefaultSettings(measurementUnitData, measurementUnits);
            var isPatched = false;
            Object.keys(allSettings).forEach((key) => {
                const value = measurementUnits[key];
                if (!value) {
                    measurementUnits[key] = allSettings[key];
                    isPatched = true;
                }
            });
            return {
                isPatched,
                measurementUnits,
            };
        };
        this.createUserConversionInfo = (proMasterConversionData, userUnitSettings) => {
            var conversionData = {};
            Object.keys(userUnitSettings).forEach((key) => {
                const typedKey = key;
                const projectDefaults = this.getProjectDefaults(proMasterConversionData.ct_conversion);
                const projectUnit = projectDefaults[typedKey];
                const matchingData = this.getUnitConverterMatch(proMasterConversionData.ct_conversion, typedKey, projectUnit, userUnitSettings[typedKey]);
                if (matchingData) {
                    conversionData[typedKey] = {
                        c1: parseFloat(matchingData.c1.toString()),
                        c2: parseFloat(matchingData.c2.toString()),
                        formula: parseInt(matchingData.formula.toString(), 10),
                        decimals: parseInt(matchingData.decimals.toString(), 10),
                        significantDigits: parseInt(matchingData.significantDigits.toString(), 10),
                        guiUnit: matchingData.guiUnit,
                        projectUnit: matchingData.projectFileUnit,
                        guiUnitType: key,
                        minValue: matchingData.minValue,
                        maxValue: matchingData.maxValue,
                    };
                }
                else {
                    conversionData[typedKey] = {
                        c1: 0,
                        c2: 1,
                        formula: 1,
                        decimals: 0,
                        guiUnit: userUnitSettings[typedKey],
                        projectUnit: projectUnit,
                        guiUnitType: key,
                        minValue: 0,
                        significantDigits: 4,
                        maxValue: "", // infinity
                    };
                }
            });
            return conversionData;
        };
        this.getUnitConverterMatch = (conversionData, key, projectUnit, guiUnit) => {
            var matchingData;
            // see if there is a match for the key on the project and gui units
            if (conversionData !== null && conversionData !== undefined) {
                matchingData = conversionData.find((tableVal) => tableVal.guiUnitType === key &&
                    tableVal.projectFileUnit === projectUnit &&
                    tableVal.guiUnit === guiUnit);
                if (matchingData) {
                    return matchingData;
                }
            }
            if (!matchingData) {
                // see if there is a match on just the project and gui units
                if (conversionData !== null && conversionData !== undefined) {
                    matchingData = conversionData.find((tableVal) => tableVal.projectFileUnit === projectUnit &&
                        tableVal.guiUnit === guiUnit);
                    if (matchingData) {
                        return matchingData;
                    }
                }
            }
            return matchingData;
        };
        this.convert = (conversionInfo, valueToConvert) => {
            if (conversionInfo === null ||
                conversionInfo === undefined ||
                typeof valueToConvert !== "number" ||
                isNaN(valueToConvert)) {
                return valueToConvert;
            }
            let result = valueToConvert;
            if (conversionInfo && conversionInfo.formula === 1) {
                result = conversionInfo.c1 + valueToConvert * conversionInfo.c2;
            }
            if (!isNaN(result)) {
                return parseFloat(result.toPrecision(conversionInfo.significantDigits)).toFixed(conversionInfo.decimals);
            }
            return result;
        };
        this.convertBack = (conversionInfo, valueToConvert) => {
            if (conversionInfo === null ||
                conversionInfo === undefined ||
                typeof valueToConvert !== "number" ||
                isNaN(valueToConvert)) {
                return valueToConvert;
            }
            let result = valueToConvert;
            if (conversionInfo && conversionInfo.formula === 1) {
                result = (valueToConvert - conversionInfo.c1) / conversionInfo.c2;
            }
            return result;
        };
        this.getConversionError = (unit, val, userUnitConversion) => {
            if (!userUnitConversion) {
                throw new Error("User unit conversion not provided.");
            }
            if (typeof val !== "number") {
                const result = new result_1.default();
                result.setStatus(statusType_1.StatusType.FAILED);
                result.log("Value to convert is not a number");
                return result;
            }
            const conversionInfo = userUnitConversion[unit];
            let result = val;
            if (conversionInfo && conversionInfo.formula == 1) {
                result = conversionInfo.c1 + val * conversionInfo.c2;
            }
            if (typeof result === "number" && !isNaN(result)) {
                result = parseFloat(result.toPrecision(conversionInfo.significantDigits)).toFixed(conversionInfo.decimals);
            }
            return rangeValidator_1.rangeValidator.validate(result, conversionInfo.minValue, conversionInfo.maxValue);
        };
        this.getConversion = (unit, val, direction, userUnitConversion) => {
            if (!userUnitConversion) {
                throw new Error("User unit conversion not provided.");
            }
            if (unit) {
                const conversionInfo = userUnitConversion[unit];
                if (direction === "in") {
                    return this.convert(conversionInfo, val);
                }
                return this.convertBack(conversionInfo, val);
            }
            throw new Error("Unit is undefined");
        };
        this.getUnitName = (unit, userUnitConversion, l) => {
            if (!userUnitConversion) {
                throw new Error("User unit conversion not provided.");
            }
            if (l === null || l === undefined) {
                return "";
            }
            let unitInfo = undefined;
            let unitPath = undefined;
            if (unit.includes(" ") || unit.includes(".")) {
                unit = unit.trim();
                unitPath = unit.split(".");
            }
            if (unitPath && unitPath.length > 0) {
                unitInfo = userUnitConversion[unitPath.pop()];
            }
            else {
                unitInfo = userUnitConversion[unit];
            }
            if (unitInfo) {
                return l("measurementUnits." + unitInfo.guiUnit);
            }
            if (unit === "") {
                return unit;
            }
            return "n/a";
        };
        this.getUnitValueResult = (unit, val, direction, userUnitConversion, l) => {
            if (!userUnitConversion) {
                throw new Error("No user unit conversion provided.");
            }
            let value = val;
            if (unit && unit.length > 0) {
                value = this.getConversion(unit, val, direction, userUnitConversion);
            }
            const unitDesc = this.getUnitName(unit, userUnitConversion, l);
            return {
                Value: value,
                UnitType: unitDesc,
            };
        };
        this.getDashboardUnitValueResult = (unit, val, direction, userUnitConversion, l) => {
            if (!userUnitConversion) {
                throw new Error("User unit conversion not provided.");
            }
            // Need to cast unit to keyof ConversionDataMap, it should not include "noPhi".
            const res = this.getUnitValueResult(unit, val, direction, userUnitConversion, l);
            res.ValueDescription = "";
            if (unit === "noErp") {
                res.erpCompliant = unit;
            }
            if (res.UnitType === "%") {
                res.UnitType = " ";
                res.ValueDescription = "%";
            }
            if (unit === "noPhi") {
                res.phiCompliant = unit;
            }
            return res;
        };
        this.getUserUnits = (measurementUnits) => {
            var _a;
            const filterObject = this.untrimProperties(measurementUnits);
            const unitConversions = (_a = this.measurementUnitsDto) === null || _a === void 0 ? void 0 : _a.ct_conversion.filter((c) => property_filter_parser_1.default.isValid(c.propertyFilter, filterObject));
            if (!unitConversions) {
                throw new Error("measurementUnitsDto has not been instanstiated!");
            }
            const userUnits = {};
            for (var i = 0; i < unitConversions.length; i++) {
                userUnits[unitConversions[i].guiUnitType] =
                    unitConversions[i].guiUnit;
            }
            return userUnits;
        };
        this.getProjectDefaults = (conversionData) => {
            const uniqueUnitTypes = conversionData.reduce((accumulator, current) => {
                if (!accumulator.some((x) => x.guiUnitType === current.guiUnitType)) {
                    accumulator.push(current);
                }
                return accumulator;
            }, []);
            const projectDefaults = {};
            for (var i = 0; i < uniqueUnitTypes.length; i++) {
                projectDefaults[uniqueUnitTypes[i].guiUnitType] =
                    uniqueUnitTypes[i].projectFileUnit;
            }
            return projectDefaults;
        };
        this.getIPDefaults = () => {
            const filterUnit = { unit: '"IP"' };
            const filterObject = {};
            if (!this.measurementUnitsDto) {
                throw new Error("measurementUnitsDto is not instanstiated!");
            }
            const measurementUnitProperties = this.measurementUnitsDto.property;
            for (var i = 0; i < measurementUnitProperties.length; i++) {
                const property = measurementUnitProperties[i].value.find((dv) => dv.value === filterUnit.unit);
                if (property) {
                    filterObject[measurementUnitProperties[i].name] = property.value;
                }
                else {
                    const defaultForIP = measurementUnitProperties[i].def_value.find((v) => property_filter_parser_1.default.isValid(v.property_filter, filterUnit));
                    if (defaultForIP) {
                        filterObject[measurementUnitProperties[i].name] = defaultForIP.value;
                    }
                }
            }
            const capacityHp = {
                capacity: '"hp"',
            };
            const pmConversionData = this.measurementUnitsDto.ct_conversion;
            const ipData = pmConversionData.filter((p) => property_filter_parser_1.default.isValid(p.propertyFilter, filterObject));
            const capacityHpData = pmConversionData.filter((p) => p.propertyFilter !== null &&
                property_filter_parser_1.default.isValid(p.propertyFilter, capacityHp));
            ipData.push.apply(ipData, capacityHpData);
            const ipDefaults = {};
            for (var i = 0; i < ipData.length; i++) {
                ipDefaults[ipData[i].guiUnitType] =
                    ipData[i].guiUnit;
            }
            return ipDefaults;
        };
        this.getSIDefaults = () => {
            if (!this.measurementUnitsDto) {
                throw new Error("measurementUnitsDto is not instanstiated!");
            }
            const filterUnit = { unit: '"SI"' };
            const filterObject = {};
            const measurementUnitProperties = this.measurementUnitsDto.property;
            for (var i = 0; i < measurementUnitProperties.length; i++) {
                const property = measurementUnitProperties[i].value.find((dv) => dv.value === filterUnit.unit);
                if (property) {
                    filterObject[measurementUnitProperties[i].name] = property.value;
                }
                else {
                    const defaultForSI = measurementUnitProperties[i].def_value.find((v) => property_filter_parser_1.default.isValid(v.property_filter, filterUnit));
                    if (defaultForSI) {
                        filterObject[measurementUnitProperties[i].name] = defaultForSI.value;
                    }
                }
            }
            const pmConversionData = this.measurementUnitsDto.ct_conversion;
            const siData = pmConversionData.filter((p) => property_filter_parser_1.default.isValid(p.propertyFilter, filterObject));
            const siDefaults = {};
            for (var i = 0; i < siData.length; i++) {
                siDefaults[siData[i].guiUnitType] =
                    siData[i].guiUnit;
            }
            return siDefaults;
        };
        this.measurementUnitsDto = measurementUnitsDto;
    }
}
exports.default = UnitConverter;
